import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const DepositComponent = React.lazy(() => import("../Components/RootComponents/DepositComponent"));
const DepositPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <DepositComponent />
      </Suspense>
    </Fragment>
  );
};

export default DepositPage;
